<template>
  <div>
    <a-button type="link"
      @click="setTheme(settings.theme === 'default' ? 'dark' : 'default')"
    >
      <i v-if="settings.theme === 'default'" class="fe fe-moon" :class="$style.icon" />
      <i v-if="settings.theme !== 'default'" class="fe fe-sun" :class="$style.icon" />
    </a-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    setTheme(nextTheme) {
      this.$store.commit('SET_THEME', { theme: nextTheme })
      this.$store.commit('CHANGE_SETTING', {
        setting: 'menuColor',
        value: nextTheme === 'dark' ? 'dark' : 'light',
      })
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
